// Shared library-taxonomy constants used by Library feature components.

// 5-phase lifecycle (collapsed from legacy 7-mode model on Feb 24, 2026):
//   define   (was scope)        — what we're building, for whom, with what boundaries
//   shape    (was design)       — architecture, interaction, data model
//   implement (was build)       — code, APIs, delivery slices
//   verify   (was review+validate) — static review + dynamic QA, fused
//   iterate  (was optimize+simulate) — post-build improvement + scenarios, fused
export const PROMPT_PHASES = ["define", "shape", "implement", "verify", "iterate"];

// Filter list always leads with "all"; phases follow.
export const MODE_FILTERS = ["all", ...PROMPT_PHASES];

// Backward-compat alias. Existing imports of MODE_FILTERS keep working;
// new components should reference PROMPT_PHASES directly.

export const PHASE_LABELS = {
  define: "Define",
  shape: "Shape",
  implement: "Implement",
  verify: "Verify",
  iterate: "Iterate",
};

export const BUILD_TYPES = [
  { value: "general", label: "General" },
  { value: "app", label: "App" },
  { value: "website", label: "Website" },
  { value: "saas", label: "SaaS" },
  { value: "api", label: "API" },
];

export const CATEGORY_TAGS = [
  "Product", "Information Architecture", "UX", "UI", "Accessibility",
  "Frontend", "Backend", "Business Logic", "State Management", "Data",
  "API", "Integrations", "Authentication & Authorization", "Security",
  "Error Handling", "Performance", "Testing", "Analytics", "Content",
  "SEO", "DevOps", "Monitoring & Reliability", "Compliance",
  "Billing & Subscriptions", "Admin & Operations",
];
